// Ported from the Polaris kit: src/components/ui/toggle/index.js.
// Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
// Change the design in the kit first, then re-port.
import { cva } from 'class-variance-authority';

export { default as Toggle } from './Toggle.vue';

export const toggleVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-polaris-md type-polaris-body font-medium hover:bg-polaris-muted hover:text-polaris-muted-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-polaris-accent data-[state=on]:text-polaris-accent-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-polaris-ring focus-visible:ring-polaris-ring/50 focus-visible:ring-[3px] outline-none transition-[color,box-shadow] aria-invalid:ring-polaris-destructive/20 dark:aria-invalid:ring-polaris-destructive/40 aria-invalid:border-polaris-destructive whitespace-nowrap",
  {
    variants: {
      variant: {
        default: 'bg-transparent',
        outline:
          'border border-solid border-polaris-input bg-transparent shadow hover:bg-polaris-accent hover:text-polaris-accent-foreground',
      },
      size: {
        default: 'h-9 px-2 min-w-9',
        sm: 'h-8 px-1.5 min-w-8',
        lg: 'h-10 px-2.5 min-w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);
